export const sanitizeCurrencyAmount = (value: string | undefined, scale = 6) => {
  if (!value) return value;
  const normalized = value.replace(',', '.').replace(/[^0-9.]/g, '');
  const [whole = '', ...fraction] = normalized.split('.');
  return fraction.length ? `${whole}.${fraction.join('').slice(0, scale)}` : whole;
};

export const isCurrencyAmount = (value: string | number | undefined, scale: number) => {
  if (!value) return true;
  const fraction = String(value).replace(',', '.').split('.')[1] || '';
  return fraction.length <= scale;
};
